import React, { Component } from 'react';
import axios from 'axios';

export class ResultDetails extends Component {
    state = {
        url: '',
        status: '',
        cntentType: '',
        loadTime: ''
    }
    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search);
        const url = queryParams.get('url');
        this.setState({url: url});

        const startTime = new Date().getTime();

        axios.get(url).then(res => {
            const currentTime = new Date().getTime();
            const loadTime = (currentTime-startTime) / 1000;
            this.setState({status: res.status});
            this.setState({contentType: res.headers['content-type']});
            this.setState({loadTime: loadTime});
          }).catch(error => {
            
          });


    }
    render() {
        return (
            <div className='container'>
                <img src={this.state.url} alt="Missing"/>
                <br/>
                <br/>
                <h3><b>{this.state.url}</b></h3>
                <br/>
                <b>Load Time: </b>{this.state.loadTime} seconds<br/>
                Configuration Method: GET<br/>
                Status: {this.state.status}<br/>
                Content-Type: {this.state.contentType}
                <br/>
                <br/>
            </div>
        )
    }
}

export default ResultDetails



// WEBPACK FOOTER //
// ./src/components/pages/ResultDetails.js